import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const styles = {
  fill: {
    height: '100%',
    width: '100%',
  },
  thumbnail: {
    height: '90%',
    width: '100%',
    padding: '5px 5px',
  },
  caption: {
    height: '10%',
  },
};

export const Thumbnail = (props) => {
  const {
    imageUrls,
    openLightbox,
    classes,
    displayPictureAmount,
  } = props;
  if (imageUrls.length < 1) return <div />;
  const background = {
    backgroundImage: `url(${imageUrls[0]})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };

  return (
    <div className={classes.fill}>
      <div
        className={displayPictureAmount ? classes.thumbnail : classes.fill}
        style={background}
        onClick={() => openLightbox()}
      />
      {displayPictureAmount && (
        <Typography className={classes.caption}>
          {`${imageUrls.length} ${imageUrls.length > 1 ? 'images' : 'image'} found!`}
        </Typography>
      )}
    </div>
  );
};

Thumbnail.propTypes = {
  imageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  openLightbox: PropTypes.func.isRequired,
  classes: PropTypes.shape({}).isRequired,
  displayPictureAmount: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Thumbnail);



// WEBPACK FOOTER //
// ./src/components/overview/PictureViewer/Thumbnail.jsx